import { Hammer, Gem, Sparkles, ScrollText } from "lucide-react";

const rows = [
  {
    icon: Hammer,
    title: "Skilled Artisans",
    desc: "Each piece passes through the hands of craftsmen trained for decades in traditional Indian silver work.",
  },
  {
    icon: Gem,
    title: "Pure 92.5 Silver",
    desc: "Only sterling silver enters our atelier — weighed, hallmarked and finished to a soft, lasting lustre.",
  },
  {
    icon: Sparkles,
    title: "Intricate Detailing",
    desc: "Filigree, granulation and fine engraving are worked patiently, never rushed, never machine-pressed.",
  },
  {
    icon: ScrollText,
    title: "Traditional Techniques",
    desc: "Methods handed down through generations — the same tools and temperaments our grandfathers used.",
  },
];

export const Craftsmanship = () => {
  return (
    <section
      id="craftsmanship"
      data-testid="craftsmanship-section"
      className="relative py-24 lg:py-32 bg-zinc-950 text-white overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.08]">
        <img
          src="https://images.unsplash.com/photo-1767786124293-289dafe6340d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85"
          alt=""
          className="h-full w-full object-cover"
        />
      </div>
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 mb-16">
          <div className="lg:col-span-6 reveal">
            <p className="text-[11px] tracking-[0.4em] uppercase text-zinc-400 mb-5">
              04 — Craftsmanship
            </p>
            <h2 className="font-display font-light text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Quiet hours, <br />
              <span className="italic silver-sheen">patient hands.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 lg:col-start-8 text-zinc-300 leading-relaxed self-end reveal reveal-delay-1">
            A piece of silver becomes an ornament only after hundreds of small
            decisions — the weight of the mould, the angle of a file, the
            softness of the polish. Here is how we keep that tradition alive.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-zinc-800 border border-zinc-800">
          {rows.map((r, i) => {
            const Icon = r.icon;
            return (
              <div
                key={r.title}
                data-testid={`craft-card-${i}`}
                className={`bg-zinc-950 p-8 lg:p-12 reveal reveal-delay-${
                  (i % 4) + 1
                }`}
              >
                <Icon
                  className="h-8 w-8 text-zinc-300"
                  strokeWidth={1.25}
                />
                <h3 className="mt-8 font-display text-2xl lg:text-3xl text-white">
                  {r.title}
                </h3>
                <p className="mt-4 text-zinc-400 leading-relaxed max-w-md">
                  {r.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
